export const radioOptions = [
  {
    value: "COE",
    label: "Used Vehicle COE",
    childValue: [
      {
        title: "Fill up Automatically",
        subinfo: "Speed up your application",
        value: "Retrieve Data",
        label: "Retrieve Data",
        time: "~ 15 mins",
      },
      {
        title: "Fill up Manually",
        subinfo: "Fill up the information by himself",
        value: "Manually",
        label: "Fill up Application Form",
        time: "~ 20-35 mins",
      },
    ],
  },

  {
    value: "PARF",
    label: "Used Vehicle PARF",
    childValue: [
      {
        title: "Fill up Automatically",
        subinfo: "Speed up your application",
        value: "Retrieve Data",
        label: "Retrieve Data",
        time: "~ 15 mins",
      },
      {
        title: "Fill up Manually",
        subinfo: "Fill up the information by himself",
        value: "Manually",
        label: "Fill up Application Form",
        time: "~ 20-35 mins",
      },
    ],
  },

  {
    value: "BODYONLY",
    label: "Body Only (Unregistered New or Import Used Vehicles)",
    childValue: [
      {
        title: "Fill up Manually",
        subinfo: "Fill up the information by himself",
        value: "Manually",
        label: "Fill up Application Form",
        time: "~ 20-35 mins",
      },
    ],
  },
];

export const stepsData = [
  { step: 1, name: "Seller & Vehicle Details" },
  { step: 2, name: "Select Your Agent" },
  { step: 3, name: "Company Details" },
  { step: 4, name: "Preview & Finalize Application Form" },
];

export const monthList = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

export const selectedLoans = [
  {
    name: "Standard Charter used",
    icon: "public/uploads/loanproduct/6501382fb7c3b.jpg",
    featured: 1,
    priority: 28,
    inhouseProduct: 0,
    displayFrom: "2023-07-09",
    displayTo: null,
    status: 1,
    createdUserRole: 1,
    updatedUserRole: 1,
    deleted_at: null,
    created_at: "2023-07-09T15:38:24.000000Z",
    updated_at: "2023-09-29T16:00:01.000000Z",
    id: "d627d7d2-36fe-4c12-b536-e1ac0691ca7f",
    loanProvider: "c7dac9d2-bc0d-4daf-9884-7d7fc82f1c4b",
    category: "81fa2796-4500-40ce-994e-e9b00a507e7b",
    productType: "08469bdc-7b03-4f3f-8b34-7cc71d048640",
    loanType: "9ec73f9f-a560-45cd-9e6b-37b126dae58a",
    usage: "6faddb7a-a70b-4209-80b4-7285003efa54",
    scheme: "c61de4b6-dba6-4cbc-b44e-9c11ce0b675c",
    motorType: "178d6856-b10d-46ee-90d2-c38519e2ec70",
    ltv: "247eed3a-cd71-4348-a58c-24f363d2026f",
    approvalTime: "237d8b1c-e11a-468c-9ba9-6084279dee86",
    inhouseAgent: null,
    agentVisibilityRule: "abfd2554-c7b0-435f-94af-94b31492a2a6",
    uniqueId: 28,
    hasPremium: 1,
    premium_priority: 5,
    createdBy: null,
    updatedBy: "b3a7af64-1224-48ad-80fe-4b2ff73bda96",
    collect_first_installment: 0,
    activeinterest: {
      id: "05c72306-6e9b-4685-951e-3000e861e28a",
      product: "d627d7d2-36fe-4c12-b536-e1ac0691ca7f",
      interest: "4",
      startDate: "2023-07-09",
      endDate: null,
      status: 1,
      createdBy: null,
      updatedBy: null,
      createdUserRole: null,
      updatedUserRole: null,
      created_at: "2023-08-31T17:26:46.000000Z",
      updated_at: "2023-10-16T10:03:22.000000Z",
      remarks1: "Test",
      remarks2: "",
      minimum_loan_amount: 10000,
      admin_fee: "100.00",
      admin_fee_status: "1",
      has_active_schedule: 0,
    },
    check: true,
  },
  {
    name: "UOB Bank Test",
    icon: "public/uploads/loanproviders/650130c509aac.jpg",
    featured: 0,
    priority: 54,
    inhouseProduct: 0,
    displayFrom: "2023-09-30",
    displayTo: "2023-10-31",
    status: 1,
    createdUserRole: 1,
    updatedUserRole: 1,
    deleted_at: null,
    created_at: "2023-09-30T16:15:00.000000Z",
    updated_at: "2023-10-05T07:22:24.000000Z",
    id: "4d122acc-3d4e-4d4b-aca9-a6a1f56617b6",
    loanProvider: "d6a5aa70-aa36-4a37-aaec-f05170f9ffb1",
    category: "81fa2796-4500-40ce-994e-e9b00a507e7b",
    productType: "08469bdc-7b03-4f3f-8b34-7cc71d048640",
    loanType: "9ec73f9f-a560-45cd-9e6b-37b126dae58a",
    usage: "6faddb7a-a70b-4209-80b4-7285003efa54",
    scheme: "c61de4b6-dba6-4cbc-b44e-9c11ce0b675c",
    motorType: "178d6856-b10d-46ee-90d2-c38519e2ec70",
    ltv: "247eed3a-cd71-4348-a58c-24f363d2026f",
    approvalTime: "237d8b1c-e11a-468c-9ba9-6084279dee86",
    inhouseAgent: null,
    agentVisibilityRule: "abfd2554-c7b0-435f-94af-94b31492a2a6",
    uniqueId: 54,
    hasPremium: 0,
    premium_priority: 0,
    createdBy: "b3a7af64-1224-48ad-80fe-4b2ff73bda96",
    updatedBy: "b3a7af64-1224-48ad-80fe-4b2ff73bda96",
    collect_first_installment: 0,
    activeinterest: {
      id: "9f4ab7e6-ecc5-4131-9d4f-d3e3c7669b03",
      product: "4d122acc-3d4e-4d4b-aca9-a6a1f56617b6",
      interest: "5.5",
      startDate: "2023-09-30",
      endDate: "2023-10-31",
      status: 1,
      createdBy: null,
      updatedBy: null,
      createdUserRole: null,
      updatedUserRole: null,
      created_at: "2023-09-30T16:15:00.000000Z",
      updated_at: "2023-10-05T08:11:05.000000Z",
      remarks1: "Test Product",
      remarks2: "Test Product",
      minimum_loan_amount: 1000,
      admin_fee: "0.00",
      admin_fee_status: "0",
      has_active_schedule: 0,
    },
    check: true,
  },
  {
    name: "Inhouse Product ABC Loan",
    icon: "public/uploads/agent/65014a6c9313c.jpg",
    featured: 1,
    priority: 51,
    inhouseProduct: 1,
    displayFrom: "2023-09-01",
    displayTo: null,
    status: 1,
    createdUserRole: 2,
    updatedUserRole: 1,
    deleted_at: null,
    created_at: "2023-09-23T06:47:06.000000Z",
    updated_at: "2023-09-29T16:00:01.000000Z",
    id: "f0a2b7ab-30a7-4531-a455-9dc571f572d3",
    loanProvider: "fc591402-bd12-4ee2-b0ab-6c1d1d538eee",
    category: "81fa2796-4500-40ce-994e-e9b00a507e7b",
    productType: "eea49ff4-655f-412e-8bb2-22e0cf8578db",
    loanType: "9ec73f9f-a560-45cd-9e6b-37b126dae58a",
    usage: "6faddb7a-a70b-4209-80b4-7285003efa54",
    scheme: "c61de4b6-dba6-4cbc-b44e-9c11ce0b675c",
    motorType: "178d6856-b10d-46ee-90d2-c38519e2ec70",
    ltv: "a856962e-c10b-4bea-a080-42c91a0a0fca",
    approvalTime: "237d8b1c-e11a-468c-9ba9-6084279dee86",
    inhouseAgent: "fc591402-bd12-4ee2-b0ab-6c1d1d538eee",
    agentVisibilityRule: "107cf868-b4a7-46cc-a555-fa2f5d61da9c",
    uniqueId: 51,
    hasPremium: 0,
    premium_priority: 11,
    createdBy: "fc591402-bd12-4ee2-b0ab-6c1d1d538eee",
    updatedBy: "b3a7af64-1224-48ad-80fe-4b2ff73bda96",
    collect_first_installment: 0,
    activeinterest: {
      id: "c5bf3525-7484-4e29-a349-c72d79c8748e",
      product: "f0a2b7ab-30a7-4531-a455-9dc571f572d3",
      interest: "4",
      startDate: "2023-09-01",
      endDate: null,
      status: 1,
      createdBy: null,
      updatedBy: null,
      createdUserRole: null,
      updatedUserRole: null,
      created_at: "2023-09-23T06:47:06.000000Z",
      updated_at: "2023-09-25T07:51:55.000000Z",
      remarks1: "tes",
      remarks2: "",
      minimum_loan_amount: 10000,
      admin_fee: "0.00",
      admin_fee_status: "0",
      has_active_schedule: 0,
    },
    check: true,
  },
  {
    name: "HSBC Bank",
    icon: "public/uploads/loanproduct/6505ba9a00a5b.jpg",
    featured: 1,
    priority: 26,
    inhouseProduct: 0,
    displayFrom: "2023-07-09",
    displayTo: null,
    status: 1,
    createdUserRole: 1,
    updatedUserRole: 1,
    deleted_at: null,
    created_at: "2023-07-09T15:20:33.000000Z",
    updated_at: "2023-10-02T02:26:40.000000Z",
    id: "6dce8090-e478-4c5b-91eb-f37ce36c3d68",
    loanProvider: "1f92b598-df65-4576-bdb7-955502e1c07a",
    category: "81fa2796-4500-40ce-994e-e9b00a507e7b",
    productType: "08469bdc-7b03-4f3f-8b34-7cc71d048640",
    loanType: "9ec73f9f-a560-45cd-9e6b-37b126dae58a",
    usage: "6faddb7a-a70b-4209-80b4-7285003efa54",
    scheme: "c61de4b6-dba6-4cbc-b44e-9c11ce0b675c",
    motorType: "178d6856-b10d-46ee-90d2-c38519e2ec70",
    ltv: "247eed3a-cd71-4348-a58c-24f363d2026f",
    approvalTime: "237d8b1c-e11a-468c-9ba9-6084279dee86",
    inhouseAgent: null,
    agentVisibilityRule: "abfd2554-c7b0-435f-94af-94b31492a2a6",
    uniqueId: 26,
    hasPremium: 0,
    premium_priority: 11,
    createdBy: null,
    updatedBy: "b3a7af64-1224-48ad-80fe-4b2ff73bda96",
    collect_first_installment: 0,
    activeinterest: {
      id: "37f5b7f7-6f82-407a-bacf-8d0fc41d7005",
      product: "6dce8090-e478-4c5b-91eb-f37ce36c3d68",
      interest: "5",
      startDate: "2023-07-09",
      endDate: null,
      status: 1,
      createdBy: null,
      updatedBy: null,
      createdUserRole: null,
      updatedUserRole: null,
      created_at: "2023-07-09T15:22:31.000000Z",
      updated_at: "2023-10-05T06:05:28.000000Z",
      remarks1: "Test remark HSBC bank",
      remarks2: "HSBC members only",
      minimum_loan_amount: 0,
      admin_fee: "0.00",
      admin_fee_status: "0",
      has_active_schedule: 0,
    },
    check: true,
  },
];

export const UploadedDocumentData = [
  {
    label: "Additional Document(s)",
    files: [
      {
        name: "TestPdf3.pdf",
        path: "public/uploads/flooring/6560858a9d9cf.pdf",
        extension: "pdf",
        size: "12.95KB",
      },
      {
        name: "Screenshot from 2023-10-22 21-12-53.png",
        path: "public/uploads/flooring/65655c90c0108.png",
        extension: "png",
        size: "193.44KB",
      },
    ],
  },
];
